import { ListItemIcon } from '@material-ui/core'
import { Drawer, ListItem,ListItemButton,List,IconButton} from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu';
import React,{useState} from 'react'
import { Link } from 'react-router-dom';
import { useContext } from "react";
import { UserContext } from './UserContext';

const DrawerComp = () => {
  const [openDrawer,setOpenDrawer]= useState(false);
  const { user, setUser } = useContext(UserContext);


  const handlelogout = () =>{
    localStorage.clear();
    setUser(null);
    window.location.href = "/";
  }

  return (
    <React.Fragment>
      <Drawer open={openDrawer} anchor='right'
      onClose={()=> setOpenDrawer(false)}
      >
        <List onClick={()=> setOpenDrawer(false)}>
          <ListItemButton component={Link} to="/dashboard">
            <ListItemIcon>
              Dashboard 
            </ListItemIcon>
            </ListItemButton>
          
            {user.accesstype === "c" ?<ListItemButton component={Link} to="/vacancies">
            <ListItemIcon >
            Vacancies                            
            </ListItemIcon>
            </ListItemButton>:<></>}
            {user.accesstype === "r" ?<ListItemButton component={Link} to="/officelocations">
            <ListItemIcon >
            Office Locations                            
            </ListItemIcon>
            </ListItemButton>:<></>}
            {user.accesstype === "r" ?<ListItemButton component={Link} to="/recruitervacancies">
            <ListItemIcon >
            Vacancies                            
            </ListItemIcon>
            </ListItemButton>:<></>}
           
            {user.accesstype === "c" ?<ListItemButton component={Link} to="/candidateApplications">
            <ListItemIcon >
              Applications                            
            </ListItemIcon>
            </ListItemButton>:<></>}
            {user.accesstype > 0 ?<ListItemButton component={Link} to="/jobs">
            <ListItemIcon >
              Job 
            </ListItemIcon>
            </ListItemButton>:<></>}
           
            {user.accesstype > 0 ?  <ListItemButton component={Link} to="/interviewdetails">
            <ListItemIcon>
              Interviews 
            </ListItemIcon>
            </ListItemButton>:<></>}
            {user.accesstype > 0 ? <ListItemButton component={Link} to="/today">
            <ListItemIcon>
            Today's 
            </ListItemIcon>
            </ListItemButton>:<></>}
            {user.accesstype > 0 ?  <ListItemButton component={Link} to="/tomorrow">
            <ListItemIcon>
             Tommorow's
            </ListItemIcon>
            </ListItemButton>:<></>}
           
            {user.accesstype > 0 ?  <ListItemButton component={Link} to="/selected">
            <ListItemIcon>
              Selected 
            </ListItemIcon>
            </ListItemButton>:<></>}
            {user.accesstype > 0 ?  <ListItemButton component={Link} to="/joined">
            <ListItemIcon>
              Joined 
            </ListItemIcon>
            </ListItemButton>:<></>}
            {user.accesstype > 0 ? <ListItemButton component={Link} to="/invoiced">
            <ListItemIcon>
              Invoiced 
            </ListItemIcon>
            </ListItemButton>:<></>}
            {user.accesstype >=0 ? <ListItemButton component={Link} to="/bookmarked">
            <ListItemIcon>
              Bookmark 
            </ListItemIcon>
            </ListItemButton>:<></>}
            {user.accesstype > 2 ?  <ListItemButton component={Link} to="/applicants">
            <ListItemIcon>
              Applicants 
            </ListItemIcon>
            </ListItemButton>:<></>}
            {user.accesstype > 2 ? <ListItemButton component={Link} to="/applicantstatus">
            <ListItemIcon>
              Rounds 
            </ListItemIcon>
            </ListItemButton>:<></>}
           
            {user.accesstype > 2 ?<ListItemButton component={Link} to="/reassign">
            <ListItemIcon>
              ReAssign 
            </ListItemIcon>
            </ListItemButton>:<></>}
            {user.accesstype > 0 ? <ListItemButton component={Link} to="/sentEmailsToCandidates" >
            <ListItemIcon>
              Emails 
            </ListItemIcon>
            </ListItemButton>:<></>}
            {user.accesstype == 5 ? <ListItemButton component={Link} to="/dataupload" >
            <ListItemIcon>
              Upload 
            </ListItemIcon>
            </ListItemButton>:<></>}
            {user.accesstype == 5 ? <ListItemButton component={Link} to="/registrations" >
            <ListItemIcon>
              Registrations 
            </ListItemIcon>
            </ListItemButton>:<></>}
            {user.accesstype == 5 ? <ListItemButton component={Link} to="/users" >
            <ListItemIcon>
              Users 
            </ListItemIcon>
            </ListItemButton>:<></>}
            {user.accesstype == 5 ? <ListItemButton component={Link} to="/devices" >
            <ListItemIcon>
              Devices 
            </ListItemIcon>
            </ListItemButton>:<></>}
            <ListItemButton component={Link} to="/" onClick={()=>handlelogout()}>
            <ListItemIcon>
              Logout
            </ListItemIcon>
            </ListItemButton>
        </List>
      </Drawer>
      <IconButton sx={{color:"white",marginLeft:"auto"}} onClick={()=> setOpenDrawer(!openDrawer)}>
      <MenuIcon/>
      </IconButton>
    </React.Fragment>
  )
}

export default DrawerComp


